import { useTypedParams } from "react-router-typesafe-routes";

import { EmployeeOwnedApplicationsCard } from "@components/Cards/EmployeeOwnedApplicationsCard/EmployeeOwnedApplicationsCard";

import { routes } from "@pages/routes";

export const ClientEmployeeOwnedApplications = () => {
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  return (
    <EmployeeOwnedApplicationsCard
      clientId={clientId}
      clientEmployeeId={clientEmployeeId}
    />
  );
};
